export class ErrorInSubscriptionDataSimple extends Error {
    constructor(key: string, description?: string) {
        super(`[EISD-${key}] Subscription data error. ${description || ''}`)
    }
}
